<template>
    <ul class="chat-content">
        <template v-for="(item,index) in messageList" v-if="messageList.length>0">
            <template v-if="messageList.length==1">
                <li class="other timeTag clearfix">{{formatDate(messageList[index].time)}}</li>
            </template>
            <template v-else>
                <li class="other timeTag clearfix" v-if="index==0&&messageList.length>1">
                    {{formatDate(messageList[index+1].time)}}
                </li>
            </template>
            <transition name="fade">
                <template v-if="item.flow=='offline_form'">
                    <chat-form :avatorSrc="avatorSrc" :item="item"></chat-form>
                </template>
            </transition>

            <transition  name="fade">
                <template v-if="item.flow=='online_form'&&!hasSubOnlineForm">
                    <online-chat-form :avatorSrc="avatorSrc" :item="item"> </online-chat-form>
                </template>
            </transition>


            <li v-if="item.flow=='in'" class="other chat-items clearfix">
                <template>
                    <img class="other-img avator"
                         v-if="messageList[index+1]&&item.flow!=(messageList[index+1].flow)||(index==messageList.length-1 && messageList[messageList.length-1].flow=='in')"
                         :src="avatorSrc" alt="">
                    <div class="other-img avator" v-else></div>
                </template>
                <span class="other-text other-hover" v-if="item.type=='text'">
                    {{toBottom(item)}}
                        <span v-html="item.text.replace(/(\r\n|\n|\r)/g, '<br />')"  :time="item.time"></span>
                     <span class="msg-time">{{formatTime(item.time)}}</span>
                </span>

                <span class="other-text other-hover" v-if="item.type=='customtext'">
                    {{toBottom(item)}}
                        <template v-if="multyLang&&multyLang[item.text]">
                             <span :time="item.time" v-html="multyLang[item.text][currentTranslateCode].replace(/(\r\n|\n|\r)/g, '<br />')"></span>
                        </template>
                        <template v-else>
                            <span :time="item.time"  v-html="item.text.replace(/(\r\n|\n|\r)/g, '<br />')"></span>
                        </template>

                     <span class="msg-time">{{formatTime(item.time)}}</span>
                </span>
                <p class="other-hover zanicon-left" v-if="item.type=='custom'&&item.content.type=='custom'">
                    {{toBottom(item)}}
                    <span class="hz-icon-zan icon iconfont icon-zan other-hover"> </span>
                    <span class="msg-time">{{formatTime(item.time)}}</span>
                </p>

                <div class="other-uploadimg" v-if="item.type=='image'">
                    <img @load="toBottom(item)" :src="item.file.url" @click="showImgView(item.file.url)" alt="">
                    <span class="msg-time">{{formatTime(item.time)}}</span>
                </div>

                <div class="other-uploadimg" v-if="item.type=='custom'&&item.content.type=='image'">
                    <img  @load="toBottom(item)" :src="item.content.fileUrl" @click="showImgView(item.content.fileUrl)" alt="">
                    <span class="msg-time">{{formatTime(item.time)}}</span>
                </div>

                <span class="other-uploadimg other-hover" v-if="item.type=='file'">
                   {{toBottom(item)}}
                     <chat-fiel-msg :fileData="item.file">
                          <span class="msg-time">{{formatTime(item.time)}}</span>
                     </chat-fiel-msg>
                </span>
                <span class="other-uploadimg other-hover" v-if="item.type=='custom'&&item.content.type=='file'">
                        {{toBottom(item)}}
                     <chat-fiel-msg :fileData="item.content">
                          <span class="msg-time">{{formatTime(item.time)}}</span>
                     </chat-fiel-msg>
                </span>
            </li>
            <li v-if="item.flow=='out'&&!(item.type=='custom'&&item.content.type=='form')" class="mine chat-items clearfix">
                <div style="display: flex;align-items: center;justify-content: flex-end">
                    <i class="el-icon-loading" v-show="item.msg_status=='sending'" style="float: right"></i>
                    <i class="el-icon-warning-outline" @click="resend(item)" v-show="item.msg_status=='fail'"></i>
                     <div class="mine-text" :class="item.msg_status=='sending'?'sending':item.msg_status=='fail'?'send-fail':'send-success'" v-if="item.type=='text'">
                          <span v-html="item.text.replace(/(\r\n|\n|\r)/g, '<br />')" :time="item.time"></span>
                         {{toBottom(item)}}
                         <span class="msg-time">{{formatTime(item.time)}}</span>
                        </div>
                    <p class="zanicon-right" v-if="item.type=='custom'&&item.content.type=='custom'">
                        <span class="hz-icon-zan">  </span>
                        {{toBottom(item)}}
                        <span class="msg-time">{{formatTime(item.time)}}</span>
                    </p>
                    <span class="mine-text mine-text-from" v-if="item.type=='custom'&&item.content.type=='onlineform'">
                        {{toBottom(item)}}
                        <form-msg :formMsg="item.content"></form-msg>
                        <span class="msg-time">{{formatTime(item.time)}}</span>
                    </span>

                    <div class="mine-uploadimg" v-if="item.type=='image'">
                        <img :src="item.file.url" @load="toBottom(item)" alt="" @click="showImgView(item.file.url)">
                        <span class="msg-time">{{formatTime(item.time)}}</span>
                    </div>
                    <div class="mine-uploadimg" v-if="item.type=='file'">
                        {{toBottom(item)}}
                      <chat-fiel-msg :fileData="item.file">
                          <span class="msg-time">{{formatTime(item.time)}}</span>
                      </chat-fiel-msg>
                </div>

                </div>

                <p class="seenStatus clearfix">
                    <span v-if="item.msg_status=='fail'" class="msg-warning">
                        fail
                    </span>
                    <span v-else-if="item.msg_status=='sending'">
                        sending
                    </span>
                    <span v-else>
                        {{serverReadLastTime>=item.time?'Read':'Unread'}}
                    </span>
                </p>
            </li>
            <template v-if="item.time">

            </template>
            <li class="other timeTag clearfix"
                v-if="messageList[index+1]&&formatDate(item.time)!=formatDate(messageList[index+1].time)">
                {{formatDate(messageList[index+1].time)}}
            </li>

        </template>
        <div class="sc-typing-indicator" v-show="isInput">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </ul>
</template>

<script>
    import imageViewer from './image-preview/index'
    import {store, mutations} from '../store/index'
    import ChatFielMsg from "./chatFileMsg";
    import chatForm from '../components/chatForm'
    import OnlineChatForm from "../components/onlineChatForm";
    import FormMsg from "./formMsg";

    export default {
        name: "chatItem",
        props: {
            msgList: {
                type: Array,
                default: []
            },
            avatorSrc: {
                type: String,
                default: ''
            }
        },
        components: {
            FormMsg,
            ChatFielMsg,
            imageViewer,
            chatForm,
            OnlineChatForm,
        },
        data() {
            return {
                messageList:[],
                hasCustomServer: false,
                zIndex: 10000,
                preview: true,
                previewSrcList: ['http://ievent.oss-cn-shanghai.aliyuncs.com/public/publicimg/%E6%99%AE%E9%80%9A%E6%A0%8F%E7%9B%AE%E5%88%9D%E5%A7%8B%E5%8C%96%E5%9B%BE.jpg']
            }
        },

        computed: {
            isInput() {
                return store.isInput
            },
            serverReadLastTime() {
                return store.serverReadLastTime
            },
            hasSubOnlineForm(){
                return store.hasSubOnlineForm
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            },
            multyLang(){
                return store.multyLang
            },
        },
        mounted(){
            this.toBottomFn();
            this.sortMsgList();
        },
        watch: {
            msgList() {
                if (store.msgList.length > 0) {
                    this.sortMsgList();
                    if( store.windowOnfocus){
                      mutations.sendMsgReceipt(store.msgList[store.msgList.length-1].time);
                    }
                }


            },
            isInput(){
                if(this.isInput){
                    this.$nextTick(() => {
                        let ele = document.getElementById('hzchat-list-box');
                        if (ele) {
                            ele.scrollTop = ele.scrollHeight;
                        }
                    })
                }

            }
        },

        methods: {
            sortMsgList(){
                this.messageList = [].concat(store.msgList);
                this.messageList.sort(function (a,b) {
                    var val1 = a.time;
                    var val2 = b.time;
                    if (val1 < val2) {
                        return -1;
                    } else if (val1 > val2) {
                        return 1;
                    } else {
                        return 0;
                    }
                })
            },

            toBottomFn() {
                this.$nextTick(() => {
                    let ele = document.getElementById('hzchat-list-box');
                    if (ele) {
                        ele.scrollTop = ele.scrollHeight;
                    }
                })
            },
            toBottom(item){
                if(item.hasOwnProperty('toBottom')&&item.toBottom==true){
                    item.toBottom = false;
                    this.toBottomFn()
                }

            },
            closeViewer() {
                this.preview = false
            },
            showImgView(url) {
                this.$emit('showImageView', url)
            },

            formatDate(val) {
                let date = new Date(val);
                return date.getFullYear() + '-' + Number(date.getMonth() + 1) + '-' + date.getDate();
            },
            formatTime(val) {
                let date = new Date(val);
                let hours = date.getHours() < 9 ? '0' + date.getHours() : date.getHours();
                let minutes = date.getMinutes() < 9 ? '0' + date.getMinutes() : date.getMinutes();
                let second = date.getSeconds() < 9 ? '0' + date.getSeconds() : date.getSeconds();
                return hours + ':' + minutes + ':' + second;
            },
            resend(msg){
                mutations.resendMsg(msg)
            },
        },

    }
</script>

<style lang="scss">
    #hz_chat_app{
        .chat-content {
            text-align: left;
            overflow: hidden;
            padding: 9px;
            li.chat-items {
                margin-bottom: 16px;
                .el-icon-loading{
                    margin-right: 8px;
                    font-size: 16px;
                }
                .el-icon-warning-outline{
                    color: #EC7775;
                    margin-right: 8px;
                    font-size: 16px;
                    font-weight: 900;
                    cursor: pointer;
                }
                .msg-warning{
                    color: #EC7775;
                    font-size: 15px;
                }
            }
            .msg-time {
                position: absolute;
                background: #2C303A;
                padding: 2px 2px;
                font-size: 12px;
                color: #fff;
                border-radius: 4px;
                top: -10px;
                display: none;
                width: 60px;
            }

            .timeTag {
                height: 20px;
                text-align: center;
                line-height: 20px;
                width: 100%;
                font-size: 12px;

            }
            .hz-icon-zan{

                padding:0px 6px 6px;
                background:rgba(50,50,50,0.3);
                border-radius: 8px;
                font-size: 40px;
                color: #0084FF;
                height: 40px;
                width: 40px;
                margin-left: 15px;
                line-height: 40px;
            }
            .other-hover:hover .msg-time {
                display: inline;
                left: 0px;
            }
            .other-uploadimg{
                position: relative;
                display: inline-block;
            }
            .other-uploadimg:hover .msg-time {
                display: inline;
                left: 0px;
            }

            .other-text .msg-time {
                line-height: 12px;
            }

            .mine-uploadimg:hover .msg-time {
                display: inline;
                right: 0px;
                top:0px;
            }

            .mine-text:hover .msg-time {
                display: inline;
                right: 0px;
            }
            .zanicon-left {
                height: 60px;
            }
            .zanicon-right{
                height: 53px;
            }
            .zanicon-right:hover .msg-time {
                display: inline;
                right: 0px;

            }

            .seenStatus {
                width: 100%;
                clear: both;
                text-align: right;
                span{
                    font-size: 12px;
                    color: #7A7A7C;
                }
            }

            .other .seenStatus {
                text-align: left;
                padding-left: 40px;
            }

            div.sc-typing-indicator {
                text-align: center;
                padding: 10px 14px;
                border-radius: 6px;
                display: inline-block;
                background: rgb(234, 234, 234);
                margin-left: 40px;
            }

            div.sc-typing-indicator span {
                display: inline-block;
                background-color: #B6B5BA;
                width: 10px;
                height: 10px;
                padding: 0;
                margin: 0;
                border-radius: 100%;
                margin-right: 3px;
                animation: bob 2s infinite;
            }

            .mine-text-from{
                transition: all 0.28s;
                -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                background: #EBEEF5;
                color: #303133;
            }
            .mine-text-from:hover{
                -webkit-box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .1), inset 0 2px 0 0 rgba(48, 71, 236, 0.5);
            }


            /*background: #;*/

            /* SAFARI GLITCH */
            .sc-typing-indicator span:nth-child(1) {
                animation-delay: -1s;
            }

            .sc-typing-indicator span:nth-child(2) {
                animation-delay: -0.85s;
            }

            .sc-typing-indicator span:nth-child(3) {
                animation-delay: -0.7s;
            }

            @keyframes bob {
                10% {
                    transform: translateY(-10px);
                    background-color: #9E9DA2;
                }
                50% {
                    transform: translateY(0);
                    background-color: #B6B5BA;
                }
            }

        }

    }


</style>
<style>
    .el-image-viewer__mask {
        position: fixed !important;
    }
</style>
